import { z } from "zod";
/** Columns the org list may be sorted by (allow-list — never a raw column name). */
export const ORG_SORT_COLUMNS = ["name", "custId"];
/** GET /api/organisations query (§7). */
export const orgListQuerySchema = z.object({
    q: z.string().trim().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    sort: z.enum(ORG_SORT_COLUMNS).default("name"),
    order: z.enum(["asc", "desc"]).default("asc"),
});
/** GET /api/orgs/:orgId/ads query — default-ad listing (§7). */
export const adListQuerySchema = z.object({
    q: z.string().trim().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    sort: z.string().trim().optional(),
    order: z.enum(["asc", "desc"]).default("asc"),
});
/** POST /api/ads/bulk-action (§7). */
export const bulkActionSchema = z.object({
    ids: z.array(z.string().min(1)).min(1),
    action: z.enum(["activate", "deactivate", "delete"]),
});
/** PATCH /api/ads/:id/status (§7). */
export const statusToggleSchema = z.object({
    status: z.union([z.literal(0), z.literal(1)]),
});
//# sourceMappingURL=api.js.map